import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { validate } from "../../../constants/validationExp";
import { toast } from "react-toastify";
import { SagaActions } from "../../../redux/actionTypes";
import { Col, Spinner } from "react-bootstrap";
import { InputWrapper } from "../auth.styled";

import RenderIf from "../../../components/renderIf";
import { getSignUpOtpReq } from "../../../api/auth/otpRequests";

import prodLogo from "../../../assets/images/logo_prod_1.png";
import devLogo from "../../../assets/images/logo_dev.png";
import stageLogo from "../../../assets/images/logo_stage.png";

import mailIcon from "../../../assets/svgIcons/mail-icon.svg";
import inactive_check_circle from "../../../assets/icons/inactive-check-circle.png";
import active_check_circle from "../../../assets/icons/active-check-circle.png";
import appLogo from "../../../assets/images/logo150.png";
import phoneIcon from "../../../assets/svgIcons/telephone-icon.svg";
import MobileNoLayout from "../../../components/compLayouts/mobileNoLayout";
import { useNavigate } from "react-router-dom";
import { ROUTE_NAMES } from "../../../constants/routeNames";
import { COUNTRY_CODES } from "../../../constants/countryCodes";

type Inputs = {
  emailIs: string;
  phoneNumberIs: string;
};

type SignUpBlockProps = {
  onSubmit: any;
  forgotPassword: boolean;
};

const SignupInfoBlock = (props: SignUpBlockProps) => {
  const { onSubmit, forgotPassword } = props;
  const navigation = useNavigate();
  const Dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<Inputs>();

  const email = watch("emailIs");
  const phNo = watch("phoneNumberIs");

  const [btnLoading, setbtnLoading] = useState(false);
  const [selectedCountryCode, setSelectedCountryCode] = useState<string>("+91");
  const _emailError = errors.emailIs?.message;
  const _passwordError = errors.phoneNumberIs?.message;
  const _validEmail = validate.email.test(email);

  const handleCountryCodeChange = (e: any) => {
    const selectedCountryCode = e.countryCode;
    const selectedCountry = COUNTRY_CODES.find(
      (country) => country.countryCode === selectedCountryCode
    );
    if (selectedCountry) {
      setSelectedCountryCode(selectedCountry.countryCode);
      // setSelectedTimeZone(selectedCountry.countryTimeZone[0].zone);
    }
  };

  const getOtpFun = async (data: any) => {
    try {
      setbtnLoading(true);
      const body = {
        role: "PAdmin",
        email: data.emailIs,
        mobile: data.phoneNumberIs,
        forgotPassword: forgotPassword,
        type: forgotPassword ? "" : "SignUp",
      };
      console.log("body", body);
      const res = await getSignUpOtpReq(body);
      setbtnLoading(false);
      toast.success(res?.message);
      localStorage.setItem("@smsOtp", res.data.smsOtp);
      localStorage.setItem("@emailOtp", res.data.emailOtp);
      localStorage.setItem("@ph", data.phoneNumberIs);
      localStorage.setItem("@email", data.emailIs);
      Dispatch({
        type: SagaActions.INFO,
        payload: {
          env: "dev",
          message: res?.message,
          fileName: "signupInfoBlock",
          methodName: "getOtpFun",
          type: "info",
        },
      });
      onSubmit({ emailIs: data.emailIs });
    } catch (error: any) {
      console.log(error, "loginPage->LoginPage->getOtpFun error");
      setbtnLoading(false);
      toast.error(error?.errorMsg);
      Dispatch({
        type: SagaActions.ERROR,
        payload: {
          env: "dev",
          message: error?.errorMsg,
          fileName: "signupInfoBlock",
          methodName: "getOtpFun",
          type: "error",
        },
      });
    }
  };

  const handleButtonClick = ({ key, data }: { key: string; data?: any }) => {
    const btnFun: any = {
      signup: (data: Inputs) => getOtpFun(data),
      login: () => navigation(ROUTE_NAMES.Initial),
      forgotPwsd: () => {},
    };
    btnFun[key](data);
  };

  return (
    <div className={`inputsContainer h-100 py-2  border-info`}>
      <Col lg={3} xs={4} sm={2} className="m-2 mb-3">
        <div className="logo_block">
          {/* <img src={appLogo} /> */}
          {process.env.REACT_APP__ENV_IS === "prod" && <img src={prodLogo} />}
          {process.env.REACT_APP__ENV_IS === "dev" && <img src={devLogo} />}
          {process.env.REACT_APP__ENV_IS === "stage" && <img src={stageLogo} />}
        </div>
      </Col>
      <div className="inputs_block w-100 py-1 px-lg-4 py-4 px-xs-2  border-info">
        <form
          onSubmit={handleSubmit((data) => {
            handleButtonClick({ key: "signup", data });
          })}
          className={` flex-1 d-flex flex-column  mx-3 h-100 border-info`}
        >
          <div className="mb-3">
            <h4 className={`x-lg-text`}>Reset password</h4>
          </div>
          <div className="">
            <InputWrapper>
              <p className={`md-text mb-1`}>{"Email ID"}</p>
              <div className="d-flex ">
                <div className="flex-grow-1 ">
                  <div
                    className={`input_box  ${_emailError && "border-danger"}`}
                  >
                    <div className={`icon_box ms-2`}>
                      <img src={mailIcon} className="" />
                    </div>

                    <input
                      className={`flex-grow-1`}
                      autoComplete="off"
                      {...register("emailIs", {
                        required: " Please enter Email",
                        pattern: {
                          value: validate.email,
                          message: "Entered incorrect email format",
                        },
                      })}
                    />

                    <div className={`icon_box me-2`}>
                      {_validEmail ? (
                        <div className={`  px-1 py-1`}>
                          <img
                            className="image_icon"
                            src={active_check_circle}
                          />
                        </div>
                      ) : (
                        <img src={inactive_check_circle} />
                      )}
                    </div>
                  </div>
                  <RenderIf isShow={!!_emailError}>
                    <p className={`x-sm-text mt-1 text-danger`}>
                      {_emailError}
                    </p>
                  </RenderIf>
                  <RenderIf isShow={!_emailError}>
                    <p className={`x-sm-text mt-1`}>
                      Corporate email ID. Example format a@b.c
                    </p>
                  </RenderIf>
                </div>
              </div>
            </InputWrapper>
          </div>
          <p></p>
          <div className="">
            <MobileNoLayout
              isError={_passwordError}
              mobileNumber={phNo}
              required
                  onCountryCodeChange={handleCountryCodeChange}
                  // countryCodeOptions={COUNTRY_CODES}
                  selectedCountryCode={selectedCountryCode}
            >
              <input
                className={`flex-grow-1 `}
                placeholder=""
                type="tel"
                maxLength={10}
                {...register("phoneNumberIs", {
                  required: "Enter 10 digit mobile number",
                  maxLength: {
                    value: 10,
                    message: "Enter 10 digit mobile number",
                  },
                  minLength: {
                    value: 10,
                    message: "Enter 10 digit mobile number",
                  },
                  pattern: {
                    value: validate.phone,
                    message: "Incorrect mobile number",
                  },
                })}
              />
            </MobileNoLayout>
          </div>
          <div className="flex-grow-1  d-flex flex-1"></div>

          <div className={``}>
            <button className={`sbmit_btn md-text`} type="submit">
              Send OTP
              <div className={`ms-2`}>
                {btnLoading && (
                  <Spinner animation="border" variant="primary" size="sm" />
                )}
              </div>
            </button>
          </div>
          <div className={`d-flex align-items-center`}>
            <p className={`x-sm-text`}>already have Account?</p>
            <button
              type="button"
              className="login_tag_btn primary-color x-sm-text"
              onClick={() => handleButtonClick({ key: "login" })}
            >
              login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignupInfoBlock;
